define('appkit/resource.manager',['require','exports','module','underscore','marionette'],function(require, exports, module) {
  var _ = require('underscore');
  var Mn = require('marionette');

  var ResourceManager = Mn.Object.extend({

    initialize: function() {
      this.requiredResponseCount = 0;
  		this.responseCount = 0;
  		this.hasError = false;
  		this.xhrPool = [];
      this.resources = [];
    },

    start: function() {
      this.isStarted = true;
      this.checkSyncComplete();
      return this;
    },

    addResource: function(resources, options) {
      if (!_.isArray(resources)) {
        resources = [resources];
      }

      options = options || {};

      _.each(resources, function(resource) {
        this.resources.push(resource);
        this.listenToOnce(resource, 'request', this._onResourceRequest);
      }, this);

      return this;
    },

    removeResource: function(resources) {
      if (!_.isArray(resources)) {
        resources = [resources];
      }

      _.each(resources, function(resource) {
        // see if we can remove this
        // resource as a dependency
        var index = _.indexOf(this.resources, resource);
        if (index >= 0) {
          this.resources.splice(index, 1);
        }
        resource.trigger('remove:resource', resource);
        this.stopListening(resource);
      }, this);

      if (this.isStarted) {
        this.checkSyncComplete();
      }

      return this;
    },

    // all models and collections need to be added in the same tick as the controller initializtion
    addDependency: function(resources, options) {
      if (!_.isArray(resources)) {
        resources = [resources];
      }

      _.each(resources, function(resource) {
        if (resource instanceof Backbone.Model && resource.isNew()) { return; }
        this.listenTo(resource, 'error', this._onDependencyError);
      }, this);

      return this.addResource(resources, options);
    },

    removeDependency: function(resources) {
      return this.removeResource(resources);
    },

    _onResourceResponse: function(resource) {
      this.responseCount++;

      // after any successful response on a resource
      // we need to remove listeners to future response
      // so we don't over increase the syncCount
      this.stopListening(resource, 'sync', this._onResourceResponse);
      this.stopListening(resource, 'error', this._onResourceResponse);
      this.stopListening(resource, 'error', this._onDependencyError);
      this.stopListening(resource, 'remove:resource', this._onResourceResponse);

      // check to see if all resources have responded
      // in some way
      this.checkSyncComplete();
    },

    _onResourceRequest: function(resource, jqXhr) {
      this.requiredResponseCount++;

      this.listenToOnce(resource, 'sync', this._onResourceResponse);
      this.listenToOnce(resource, 'error', this._onResourceResponse);
      this.listenToOnce(resource, 'remove:resource', this._onResourceResponse);

      var done = function() {
        // remove the xhr from the pool.  We're done with it.
        this.xhrPool.splice(_.indexOf(this.xhrPool, jqXhr), 1);
        this.stopListening(resource, 'sync', done);
        this.stopListening(resource, 'error', done);
      };
      this.listenTo(resource, 'sync error', done);
      this.xhrPool.push(jqXhr);
    },

    _onDependencyError: function(resource, error, xhr) {
      this.stopListening(resource);
      this.triggerError(error, xhr);
    },

    triggerError: function(error, xhr) {
      if (!this.hasError) {
        this.hasError = true;
        this.trigger('error', error, xhr);
      }
    },

    checkSyncComplete: function() {
      var self = this;
      _.defer(function() {
        if (self.isDone()) {
          self.triggerLoaded();
        }
      });
      return this;
    },

  	// page successfully loaded
  	triggerLoaded: function() {
      if (!this.hasLoaded) {
        this.hasLoaded = true;
        this.trigger('loaded');
      }
		},

		abortPendingResources: function() {
      var xhrPool = this.xhrPool;
      this.xhrPool = [];
			_.each(xhrPool, function(jqXhr) {
				jqXhr.abort();
			});
		},

    isDone: function() {
  	  return this.responseCount >= this.requiredResponseCount && !this.hasError;
  	},

    onDestroy: function() {
      if (!this.isDone()) {
	  		this.abortPendingResources();
  		  this.trigger('cancel');
  		}
      // lets clean this stuff up
      _.each(this.resources, function(resource) {
        resource.stopListening();
      });
    }

  });

  module.exports = ResourceManager;
});

